module.exports = __webpack_public_path__ + "static/the-cosmos-yonatan-vinitsky-6dcd27ff4ceb2489b743c1608abd2ff5.png";